module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.finalSize.x,
      "height": _vm.finalSize.y,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('MeshCanvasMaterial', {
    attrs: {
      "canvas": _vm.canvas,
      "color": _vm.color,
      "image": _vm.link
    },
    on: {
      "exec": function (v) {
        _vm.$emit('exec', v)
      },
      "texture": function (v) {
        _vm.$emit('texture', v)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7625df13","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebGL/Custom/CanvasMesh.vue
// module id = 603
// module chunks = 0